import { InjectionToken } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { UserType } from '../../../../common/constants/user-types.constants';
import { AccessKeyResponse } from '../../../../common/services/workflow-access-key/workflow-access-key.service';

export interface RequestAfterActionContext {
  requestType: string;
  userType: UserType | null;
}

export interface RequestNavigationTarget {
  commands: string[];
  queryParams?: Params;
}

export interface RequestContextAdapter {
  getAfterActionNavigation(
    context: RequestAfterActionContext
  ): RequestNavigationTarget;

  getHomePath(): string;

  /** Header collaborators UI (employee-only). */
  showCollaboratorsSection(): boolean;

  /** Form footer save action (employee-only). */
  showSaveAction(): boolean;

  /** Discussion / request-view-actions panel (employee-only). */
  showRequestViewActions(): boolean;

  /** Hold / resume form actions (employee-only). */
  showHoldResumeActions(): boolean;

  getStepAuthorizationKey(
    stepId: string | number,
    userId?: string | number | null
  ): Observable<AccessKeyResponse>;

  refreshStepAuthorizationKey(
    stepId: string | number
  ): Observable<{ message: string }>;

  getFormSection(stepId: string | number): Observable<unknown>;

  takeStepAction(form: unknown, stepId: string | number): Observable<unknown>;

  saveRequest(form: unknown, stepId: number): Observable<unknown>;

  getFlowSteps(flowId: string | number): Observable<unknown>;

  getFlowStepsDetails(flowId: string | number): Observable<unknown>;
}

export const REQUEST_CONTEXT_ADAPTER =
  new InjectionToken<RequestContextAdapter>('REQUEST_CONTEXT_ADAPTER');
